import { FC } from "react";

import { ActionIcon, Affix, Button, HoverCard } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconMailShare } from "@tabler/icons-react";

import classes from "../../styles/components/modals/CreateMailModal.module.scss";
import { MailForm } from "../forms/MailForm.tsx";

interface MailFormComponentProps {
  onClose: () => void;
}

const MailFormComponent: FC<MailFormComponentProps> = ({ onClose }) => {
  return (
    <>
      <MailForm />
      <Button className={classes.button} onClick={onClose} variant="default">
        Cancel
      </Button>
    </>
  );
};

export const CreateMailModal = () => {
  return (
    <Affix position={{ bottom: 80, right: 80 }}>
      <HoverCard shadow="md">
        <HoverCard.Target>
          <ActionIcon
            radius="xl"
            size={50}
            onClick={() => {
              modals.open({
                title: <h2 style={{ fontWeight: "bold" }}>New mail</h2>,
                size: "xl",
                children: <MailFormComponent onClose={modals.closeAll} />
              });
            }}
          >
            <IconMailShare stroke={1.5} size={30} />
          </ActionIcon>
        </HoverCard.Target>
        <HoverCard.Dropdown>New mail</HoverCard.Dropdown>
      </HoverCard>
    </Affix>
  );
};
